import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';
import { FieldWidthEnum } from '@data/cer-data-types';

export class RoyaltyHistoryForm extends CerFormAdapter {

    override viewSetInit(viewSet: CerFormViewSet): void {
        const navProject = this.routeOptions.navigation?.columnNameChild == 'projectNum';
        const view = RoyaltyHistoryForm.viewGet(navProject);
        viewSet.viewAdd(view);
    }

    public static viewGet(navProject: boolean): CerFormView {

        const view = new CerFormView();
        view.viewType = 'list';
        view.viewMetadata = {
            name: 'royalty-history', dataApiName: 'RoyaltyAfregningTransHistorikView',
            text: 'Royalty historik',
            primaryKey: 'id', baseFields: ['id'],
            allowCreate: false, allowEdit: false, allowDelete: false,
            navigations: [
                { link: 'navMenu', linkMenu: 'Kontrakt', title: 'Royalty, godkendelse', paneTarget: 'bottom', foreignKey: { parentEntity: 'RoyaltyAfregningAktuelView', parentColumn: 'hovedkontrakt', column: 'hovedkontrakt' } },
                { link: 'navMenu', linkMenu: 'Kontrakt', title: 'Royalty, historik', paneTarget: 'bottom', foreignKey: { parentEntity: 'RoyaltyAfregningTransHistorikView', parentColumn: 'hovedkontrakt', column: 'hovedkontrakt' } }
            ]
    };

        view.fieldMetadata =
        [{ name: 'isbn', text: 'ISBN' },
        { name: 'bogtitel', text: 'Titel', widthType: FieldWidthEnum.XXL },
        { name: 'edition', text: 'Udgave' },
        {
            name: 'hid', text: 'Projekt', widthType: FieldWidthEnum.M,
            foreignKeyTableName: 'RefDataProductLookup', foreignKeyField: 'projectLegacyId', foreignKeyValue: 'projectNum',
        },
        {
            name: 'fid', text: 'Forlag/Agent', widthType: FieldWidthEnum.XXXXL,
            foreignKeyTableName: 'Forfatter', foreignKeyField: 'id', foreignKeyValue: 'idNavn'
        },
        { name: 'dato', text: 'Dato', format: 'DateShort', orderBy: 'Descending' },
        { name: 'type', text: 'Type', widthType: FieldWidthEnum.XXS },
        { name: 'omsAntal', text: 'Antal solgt', format: 'Integer', widthType: FieldWidthEnum.S, footerType: 'Sum' },
        { name: 'omsBelobVal', text: 'Omsætning', format: 'Amount0', widthType: FieldWidthEnum.S, footerType: 'Sum' },
        { name: 'royaltyBelobBeregnVal', text: 'Royalty', format: 'Amount0', widthType: FieldWidthEnum.S, footerType: 'Sum' },
        { name: 'valutaKode', text: 'Valuta' }
        ];

        return view;
    }
}